import { ActionReducerMap } from "@ngrx/store";

import { State, reducer } from "./auth.reducer";

export interface AuthState {
  status: State;
}

export const authReducer: ActionReducerMap<AuthState> = {
  status: reducer
};

export * from "./auth.reducer";
